import React, { Component } from "react";

import CustomSelect from "../../elements/CustomSelect/CustomSelect";
import { withRouter } from "react-router-dom";

class CompanySelect extends Component {
  constructor(props) {
    super();
    this.inputRef = React.createRef();
  }
  fetchAutocompleteData = async input => {
    // console.log("fetchAutocompleteData");
    const response = await this.props.refetch({ name: input });
    console.log("response from refetch", response.data.allCompanies);
    return {
      options: response.data.allCompanies.map(company => {
        return {
          label: company.name,
          value: company
        };
      })
    };
  };

  onSelected = e => {
    console.log("selected", e);
    sessionStorage.setItem("companyId", e.company.value.id);
    this.props.history.replace("/dashboard");
    this.props.onSelected && this.props.onSelected(e);
  };

  // focusStateSelect = () => {
  // 	this.refs.stateSelect.focus();
  // }

  render() {
    console.log("CompanySelect props", this.props);
    return (
      <CustomSelect
        value={this.props.value || ""}
        ref={this.inputRef}
        displaysOptionsAt={0}
        label="company"
        creatable={false}
        multi={false}
        fetchData={this.fetchAutocompleteData.bind(this)}
        autoload={true}
        onSelected={this.onSelected}
        autofocus
      />
    );
  }
}

export default // graphql(Queries.GET_USER_COMPANIES, {
//   name: "GetUserCompanies",
//   skip: (ownProps) => !ownProps.userId,
//   props: ({ GetUserCompanies, GetUserCompanies: { refetch } }) => ({
//     refetch,
//     GetUserCompanies
//   })})

withRouter(CompanySelect);
